<template>
  <div>
    <base-header class="pb-8 pt-4">
      <!-- Card stats -->
      <div class="row">
        <div class="col-md-3 col-sm-12">
          <stats-card
              :title="$t('Toplam Gelir')"
              :sub-title="`${income} TL`"
              icon="fas fa-chart-bar"
              class="mb-4 mb-xl-0 bg-gradient-info">
          </stats-card>
        </div>

        <div class="col-md-3 col-sm-12">
          <stats-card
              :title="$t('Toplam Gider')"
              :sub-title="`${expense} TL`"
              icon="fas fa-chart-bar"
              class="mb-4 mb-xl-0 bg-gradient-danger">
          </stats-card>
        </div>

        <div class="col-md-3 col-sm-12">
          <stats-card
              :title="$t('NET KÂR')"
              :sub-title="`${income - expense} TL`"
              icon="fas fa-chart-bar"
              class="mb-4 mb-xl-0 bg-gradient-success">
          </stats-card>
        </div>

        <div class="col-md-3 col-sm-12">
          <stats-card
              :title="$t('İşlem Sayısı')"
              type="gradient-red"
              :sub-title="`${processes}`"
              icon="ni ni-diamond"
              class="mb-4 mb-xl-0 bg-gradient-warning">
          </stats-card>
        </div>

        <div class="col-md-3 col-sm-12 mt-4" v-for="(incometype,id) in incometypes" v-bind:key="id">
          <stats-card
              :title="incometype.payment_type+' Geliri'"
              type="gradient-red"
              :sub-title="`${incometype.price} TL`"
              icon="ni ni-diamond"
              class="mb-4 mb-xl-0 bg-gradient-primary">
          </stats-card>
        </div>

        <div class="col-md-3 col-sm-12 mt-4">
          <stats-card
              :title="$t('Dünden Devreden (Nakit) ')"
              type="gradient-red"
              :sub-title="`${inSafeMoney} TL`"
              class="mb-4 mb-xl-0 bg-gradient-warning">
          </stats-card>
        </div>

<!--        <div class="col-md-3 col-sm-12 mt-4">-->
<!--          <stats-card-->
<!--              :title="$t('Kasadaki Toplam (Nakit) ')"-->
<!--              type="gradient-red"-->
<!--              :sub-title="`${dailyCash} TL`"-->
<!--              class="mb-4 mb-xl-0 bg-gradient-warning">-->
<!--          </stats-card>-->
<!--        </div>-->

        <div class="col-md-3 col-sm-12 mt-4">
          <stats-card
              :title="$t('Kasadaki Toplam Para')"
              :sub-title="`${dailyCash} TL`"
              icon="fas fa-chart-bar"
              class="mb-4 mb-xl-0 bg-gradient-danger">
          </stats-card>
        </div>
      </div>



    </base-header>


    <div class="container-fluid mt--7">
      <b-card no-body>
        <b-card-header>
          <div class="align-items-center row">
            <div class="col d-flex align-items-center">
              <h3 class="card-title mb-0">{{ $t('Günlük Kasa') }}</h3>
              <div class="text-sm ml-4" style="width:200px;">
                <b-form-group class="mb-0">
                  <b-form-select v-model="filterType" :options="[
                    { text: $t('Tümü'), value: 'all' },
                    { text: $t('Nakit'), value: 'cash' },
                    { text: $t('Çek'), value: 'check' },
                    { text: $t('Senet'), value: 'bill' },
                    { text: $t('Kredi Kartı'), value: 'credit_cart' },
                    { text: $t('Havale / EFT'), value: 'eft' },
                  ]" @change="refreshTable"/>
                </b-form-group>
              </div>
            </div>
          </div>
        </b-card-header>

        <b-table
            ref="table"
            class="align-items-center"
            thead-class="thead-light"
            :fields="[
            { key: 'title', label: 'Başlık' },
            { key: 'category.name', label: 'Kategori' },
            { key: 'client.full_name', label: 'Müşteri Adı' },
            { key: 'client.gsm', label: 'Müşteri Telefonu' },
            { key: 'price', label: 'Ücret' },
            { key: 'date', label: 'Ödeme Tarihi' },
            { key: 'payment_type', label: 'Ödeme Şekli' },
            { key: 'actions', label: '', tdClass: 'text-right' },
          ]"
            :items="items"
            show-empty>

          <template v-slot:empty>
            <div class="text-center">
              Henüz hiçbir kayıt girmemişsiniz!
            </div>
          </template>

          <template v-slot:table-busy>
            <div style="width: 100%; text-align:center;">
              <b-spinner label="Spinning"></b-spinner>
            </div>
          </template>

          <template v-slot:cell(title)="data">
            {{ data.item.title }}
            <b-badge variant="success" v-if="data.item.type === 'income'">{{ $t('GELİR') }}</b-badge>
            <b-badge variant="danger" v-else-if="data.item.type === 'expense'">{{ $t('GİDER') }}</b-badge>
            <b-badge variant="info" v-else-if="data.item.type === 'credit'">{{ $t('ALACAK') }}</b-badge>
            <b-badge variant="warning" v-else>{{ $t('BORÇ') }}</b-badge>
          </template>

          <template v-slot:cell(payment_type)="data">
            {{ paymentType(data.item.payment_type) }}
          </template>

          <template v-slot:cell(actions)="data">
            <b-button variant="warning" size="sm" @click="showAccounting(data.item)">{{ $t('Görüntüle') }}</b-button>
            <b-button v-if="data.item.type === 'credit'" variant="info" size="sm" @click="openTypeModal(data.item)">
              {{ $t('Ödeme Alındı') }}
            </b-button>
            <b-button v-if="data.item.type === 'debt'" variant="info" size="sm" @click="openToExpenseModal(data.item)">
              {{ $t('Ödeme Tamamla') }}
            </b-button>
            <b-button variant="danger" size="sm" @click="deleteAccountingAction(data.item.id)">{{
                $t('Sil')
              }}
            </b-button>
          </template>

        </b-table>
        <div class="w-full text-right p-3">
          <b-button variant="primary" @click="printData">{{ $t('Gün Sonu Al') }}</b-button>
          <b-button variant="info" @click="printDataExcel">{{ $t('Excel Rapor Al') }}</b-button>
        </div>
      </b-card>
    </div>

    <b-modal ref="accountingModal" :title="$t('İşlem Detayları')">
      <b-table :fields="[
        { key: 'service.name', label: 'Başlık', },
        { key: 'piece', label: 'Adet', },
        { key: 'price', label: 'Fiyat', },
        { key: 'discount', label: 'İndirim', },
        { key: 'tax', label: 'KDV Oranı', },
      ]" :items="accounting.services" bordered/>
      <template v-slot:modal-footer>
        <b-button @click="$refs.accountingModal.hide()" variant="primary">{{ $t('Kapat') }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import moment from 'moment';

export default {

  data() {
    return {
      company: {},
      dailyCash:0,
      accounting: {},
      income: '',
      inSafeMoney: null,
      incometypes: [],
      expense: '',
      processes: '',
      filterType: 'all',
      records: [],
    }
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    ...mapActions(['getSafe', 'deleteAccounting','printExcel']),
    itemType(t) {
      switch (t) {
        case 'income':
          return 'GELİR';
        case 'expense':
          return 'GİDER';
        case 'credit':
          return 'ALACAK';
        default:
          return 'BORÇ';
      }
    },
    printData() {
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      let items = '';
      console.log(this.records)
      this.records.forEach(item => {
        items += `<tr>
            <td>${this.itemType(item.type)} - ${item.title}</td>
            <td>${item.category ? item.category.name : ''}</td>
            <td>${item.client ? item.client.full_name : ''}</td>
            <td>${item.client ? item.title : ''}</td>
            <td>${item.price}</td>
            <td>${item.date}</td>
            <td>${this.paymentType(item.payment_type)}</td>
          </tr>`;
      });
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
          </head>
          <body>
            <h1>Gün Sonu</h1>
            <pre><b>Firma : </b> ${this.company.title || ''}</pre>
            <pre><b>Rapor Tarihi : </b> ${moment().format('DD.MM.YYYY')}</pre>
            <pre><b>Gelir : </b> ${this.income}</pre>
            <pre><b>Gider : </b> ${this.expense}</pre>
            <pre><b>Kâr : </b> ${this.income - this.expense}</pre>
            ${
          this.incometypes.map(incometype => {
            return `<pre><b>${incometype.payment_type}</b>  : ${incometype.price}</pre>`
          }).join(" ")
      }

            <pre><b>Dünden Devreden : </b> ${this.inSafeMoney} TL</pre>
            <pre><b>Kasadaki Toplam Para</b> ${this.dailyCash} TL</pre>
            <table style="width:100%" border="1">
              <thead>
                <tr>
                  <th style="text-align:left;"><b>Başlık</b></th>
                  <th style="text-align:left;"><b>Kategori</b></th>
                  <th style="text-align:left;"><b>Müşteri Adı</b></th>
                  <th style="text-align:left;"><b>Açıklama</b></th>
                  <th style="text-align:left;"><b>Ücret</b></th>
                  <th style="text-align:left;"><b>Ödeme Tarihi</b></th>
                  <th style="text-align:left;"><b>Ödeme Şekli</b></th>
                </tr>
              </thead>
              <tbody>
                ${items}
              </tbody>
            </table>
          </body>
        </html>`);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    deleteAccountingAction(id) {
      this.$swal({
        icon: 'warning',
        title: 'Dikkat',
        text: 'İşlem kalıcı olarak silinecektir, emin misiniz?',
      }).then(ok => {
        if (ok.value) {
          this.deleteAccounting(id).then(res => {
            this.success(res.data.message);
            this.refreshTable();
          }).catch(error => {
            this.error(error.response.data.message);
          });
        }
      });
    },
    showAccounting(data) {
      this.accounting = data;
      this.$refs.accountingModal.show();
    },
    refreshTable() {
      setTimeout(() => {
        this.$refs.table.refresh();
      }, 200);
    },
    paymentType(type) {
      switch (type) {
        case 'credit_cart':
          return 'Kredi Kartı';
        case 'eft':
          return 'Havale / EFT';
        case 'check':
          return 'Çek';
        case 'bill':
          return 'Senet';
        default:
          return 'Nakit';
      }
    },
    printDataExcel(){
      this.printExcel({
        inSafeMoney:this.inSafeMoney,
        dailyCash:this.dailyCash
      }).then(res=>{
        location.href=res.data.file
      }).catch(err=>{
        this.error('Bir Hata İle Karşılaşıldı!');
      })
    },
    items() {
      const parameters = this.parameters();
      return this.getSafe(parameters).then(data => data.data).then(response => {
        this.inSafeMoney = response.inSafeMoney;
        this.income = response.income;
        this.expense = response.expense;
        this.processes = response.process_count;
        this.incometypes = response.incomeGroup;

        let t=this.incometypes.findIndex(ic=>ic.payment_type=='Nakit')
        if(t!=-1){
          this.dailyCash=this.inSafeMoney+this.incometypes[t].price-this.expense;
        }else{
          this.dailyCash=this.inSafeMoney-this.expense
        }

        const records = response.records;
        if (records && records.length > 0)
          this.company = records[0].company
        this.records = records;
        return records;
      }).catch(error => {
        this.error(error.response.data.message);
      })
    },
    parameters() {
      const params = {};
      params.payment_type = this.filterType;
      return params;
    }
  }
}
</script>
